import { render, staticRenderFns } from "./add-extend-other.vue?vue&type=template&id=a4b5119c&"
import script from "./add-extend-other.vue?vue&type=script&lang=js&"
export * from "./add-extend-other.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports